import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import clsx from "clsx";
import * as React from "react";

interface HoverCardProps
	extends React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Root> {
	openDelay?: number;
	closeDelay?: number;
}

const HoverCard = React.forwardRef<
	React.ElementRef<typeof HoverCardPrimitive.Root>,
	HoverCardProps
>(({ openDelay = 0, closeDelay = 0, ...props }, ref) => (
	<HoverCardPrimitive.Root
		ref={ref}
		openDelay={openDelay}
		closeDelay={closeDelay}
		{...props}
	/>
));
HoverCard.displayName = HoverCardPrimitive.Root.displayName;

const HoverCardTrigger = React.forwardRef<
	React.ElementRef<typeof HoverCardPrimitive.Trigger>,
	React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
	<HoverCardPrimitive.Trigger
		ref={ref}
		className={clsx("cursor-pointer", className)}
		{...props}
	>
		{children}
	</HoverCardPrimitive.Trigger>
));
HoverCardTrigger.displayName = HoverCardPrimitive.Trigger.displayName;

const HoverCardContent = React.forwardRef<
	React.ElementRef<typeof HoverCardPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, children, ...props }, ref) => (
	<HoverCardPrimitive.Portal>
		<HoverCardPrimitive.Content
			ref={ref}
			side="top"
			align="center"
			className={clsx(
				"z-50 w-[420px] shadow-lg border border-border/50 bg-background rounded-md transition-all",
				className,
			)}
			{...props}
		>
			{children}
		</HoverCardPrimitive.Content>
	</HoverCardPrimitive.Portal>
));
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent };
